import { render, staticRenderFns } from "./RideitChangeRequestTableItem.vue?vue&type=template&id=7c31da3c"
import script from "./RideitChangeRequestTableItem.vue?vue&type=script&lang=ts"
export * from "./RideitChangeRequestTableItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports